<template>
  <v-flex>

    <v-layout align-center column fill-heigh justify-center wrap>
      <v-card class="pa-5" style="max-width: 960px; ">
        <!--        <v-flex md12>-->
        <v-card-text class="text-xs-right pb-1 pt-1">Ректору Российского химико-технологического</v-card-text>
        <v-card-text class="text-xs-right  pb-1 pt-1 ">университета имени Д.И. Менделеева</v-card-text>
        <v-card-text class="text-xs-right  pb-1 pt-1 ">Мажуге Александру Георгиевичу</v-card-text>

        <v-card-text class="text-xs-center  pb-5 pt-5 "><strong>Ходатайство о создании постоянно действующего
          диссертационного совета</strong>
        </v-card-text>
        <v-layout row wrap class="pb-2 pt-2">
          <v-flex xs12>
            <v-autocomplete
              class="mr-3 ml-3"
              outline
              :loading="loaders.departments.status"
              :error="hasError('departments')"
              :error-messages="getError('departments')"
              :items="selectors.department.items"
              :item-disabled="selectors.department.disabled"
              no-data-text="Нет данных"
              label="Подразделение"
              v-model="value.departments"
              multiple
              disabled
            ></v-autocomplete>
          </v-flex>
        </v-layout>
        <v-card-text class="text-xs-justify pb-1 pt-1 ">
          в соответствии с Положением о присуждении ученых степеней в федеральном государственном
          бюджетном образовательном учреждения высшего образования «Российский химико-технологический
          университет имени Д.И. Менделеева» и Положением о диссертационном совете федерального государственного
          бюджетного образовательного учреждения высшего образования «Российский химико-технологический университет
          имени Д.И. Менделеева» ходатайствует о создании постоянно действующего диссертационного совета по
        </v-card-text>

        <template v-for="(str, index) in value.specialities">

          <v-layout row wrap class=" pb-1 pt-3">

            <v-flex md5>
              <v-autocomplete
                class="mr-3 ml-3"
                outline
                :error="getErrorArray('specialities')"
                :error-messages="getErrorArrayField('specialities','speciality')"
                :items="selectors.speciality"
                no-data-text="Нет данных"
                label="Научная специальность"
                v-model="value.specialities[index].speciality"
                :item-text=text
                :item-value=text
                :disabled=disabled
              ></v-autocomplete>
            </v-flex>
            <v-flex md5>
              <v-autocomplete
                class="mr-3 ml-3"
                outline
                :error="getErrorArray('specialities')"
                :error-messages="getErrorArrayField('specialities','branch')"
                :items="selectors.branch"
                no-data-text="Нет данных"
                label="Отрасли науки"
                v-model="value.specialities[index].branch"
                :disabled=disabled
              ></v-autocomplete>
            </v-flex>
            <v-flex md1>
              <v-btn v-if=" value.specialities.length > 1 " icon @click="deleteData(index,'specialities')"
                     :disabled=disabled>
                <v-icon class="material-icons">
                  clear
                </v-icon>
              </v-btn>
            </v-flex>

            <v-flex md1>
              <v-btn icon @click="addData" v-if=" index ===0" class="primary" :disabled=disabled>
                <v-icon class="material-icons">
                  add
                </v-icon>
              </v-btn>
            </v-flex>

          </v-layout>
        </template>
        <v-divider class="pt-2 "></v-divider>
        <v-layout row wrap class=" pb-1 pt-3">
          <v-flex md5>
            <v-card-text class="text-xs-justify ">Председатель диссертационного совета</v-card-text>
          </v-flex>
          <v-flex md7>
            <v-autocomplete
              ref="responsible"
              class="mr-3 ml-3"
              :loading="loaders.responsible.status"
              outline
              :error="hasError('chairman')"
              :error-messages="getError('chairman')"
              :items="selectors.responsible"
              no-data-text="Нет данных"
              label="Председатель"
              v-model="value.chairman"
              :disabled=disabled
            ></v-autocomplete>
          </v-flex>
        </v-layout>
        <v-divider class="pt-2 "></v-divider>
        <template v-for="(str, index) in value.vice_chairmans">
          <v-layout row wrap>
            <v-flex md5>
              <v-card-text class="text-xs-justify ">Заместитель председателя диссертационного совета</v-card-text>
              <v-checkbox
                class="mr-3 ml-3  pb-0 pt-0"
                label="Заместитель пр. из другой организации"
                v-model="value.vice_chairmans[index].type"
                :disabled=disabled
              ></v-checkbox>
            </v-flex>

            <v-flex md6 class="  pb-0 pt-0">
              <v-autocomplete
                v-if="! value.vice_chairmans[index].type"
                ref="responsible"
                class="mr-3 ml-3  pb-0 pt-0"
                :loading="loaders.responsible.status"
                outline
                :error="hasError('vice_chairmans')"
                :error-messages="getErrorArrayField('vice_chairmans','worker')"
                :items="selectors.responsible"
                :disabled=disabled
                no-data-text="Нет данных"
                label="Сотрудник"
                v-model="value.vice_chairmans[index].worker"

              ></v-autocomplete>
              <v-layout row wrap v-else>
                <v-text-field
                  class="mr-3 ml-3"
                  label="ФИО сотрудника"
                  outline
                  :disabled=disabled
                  v-model="value.vice_chairmans[index].fio"
                ></v-text-field>

                <v-text-field
                  class="mr-3 ml-3"
                  label="Организация"
                  outline
                  :disabled=disabled
                  v-model="value.vice_chairmans[index].organization"
                ></v-text-field>
              </v-layout>
            </v-flex>
<v-layout >
  <v-flex md1>
    <v-btn icon @click="addDataChairman" v-if="value.vice_chairmans.length  <= 1" class="primary">
      <v-icon class="material-icons">
        add
      </v-icon>
    </v-btn>
    <v-flex md1>
      <v-btn v-if=" value.vice_chairmans.length > 1 " class="primary" icon
             @click="deleteData(index,'vice_chairmans')">
        <v-icon class="material-icons">
          clear
        </v-icon>
      </v-btn>
    </v-flex>
  </v-flex>
</v-layout>


          </v-layout>
          <v-divider class="pt-2 "></v-divider>
        </template>

        <v-layout row wrap>
          <v-flex md5>
            <v-card-text class="text-xs-justify ">Ученый секретарь диссертационного совета</v-card-text>
          </v-flex>
          <v-flex md7>
            <v-autocomplete
              ref="responsible"
              class="mr-3 ml-3"
              :loading="loaders.responsible.status"
              outline
              :error="hasError('scientific_secretary')"
              :error-messages="getError('scientific_secretary')"
              :items="selectors.responsible"
              no-data-text="Нет данных"
              label="Сотрудник"
              v-model="value.scientific_secretary"
              :disabled=disabled
            ></v-autocomplete>
          </v-flex>
        </v-layout>
        <v-divider class="pt-2 "></v-divider>
        <v-layout row wrap>
          <v-flex md7>
            <v-card-text class="text-xs-justify ">Состав диссертационного совета</v-card-text>
          </v-flex>
          <v-flex md2>
            <v-text-field
              type="number"
              class="mr-3 ml-3"
              :error="hasError('count_council_members')"
              :error-messages="getError('count_council_members')"
              v-model="value.count_council_members"
              :disabled=disabled
            ></v-text-field>
          </v-flex>
          <v-flex md3>
            <v-card-text class="text-xs-justify "> членов, в т.ч.:</v-card-text>
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex md7>
            <v-card-text class="text-xs-justify ">докторов наук
            </v-card-text>
          </v-flex>
          <v-flex md2>
            <v-text-field
              type="number"
              class="mr-3 ml-3"
              :error="hasError('count_doctors')"
              :error-messages="getError('count_doctors')"
              v-model="value.count_doctors"
              :disabled=disabled
            ></v-text-field>
          </v-flex>
          <v-flex md3>
            <v-card-text class="text-xs-justify "> чел</v-card-text>
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex md7>
            <v-card-text class="text-xs-justify ">штатных сотрудников РХТУ им. Д.И. Менделеева
            </v-card-text>
          </v-flex>
          <v-flex md2>
            <v-text-field
              type="number"
              class="mr-3 ml-3"
              :error="hasError('count_staff')"
              :error-messages="getError('count_staff')"
              v-model="value.count_staff"
              :disabled=disabled
            ></v-text-field>
          </v-flex>
          <v-flex md3>
            <v-card-text class="text-xs-justify "> чел</v-card-text>
          </v-flex>
        </v-layout>

        <v-divider class="pt-2 "></v-divider>
        <v-layout row wrap>
          <v-card-text class="text-xs-justify ">Обоснование необходимости создания диссертационного совета
          </v-card-text>
          <v-textarea
            outline
            class="mr-3 ml-3"
            v-model="value.rationale"
            :disabled=disabled
          >

          </v-textarea>
        </v-layout>
        <v-divider class="pt-2 "></v-divider>
        <v-layout colum wrap class=" pb-0 pt-0">
          <v-flex md2>
            <v-card-text class="text-xs-justify ">Приложение:</v-card-text>
          </v-flex>
          <v-flex md10>
            <v-card-text class="text-xs-justify ">1. Сведения о кандидатах в члены диссертационного совета.
            </v-card-text>
            <v-card-text class="text-xs-justify ">2. Сведения о публикационной активности кандидатов в члены
              диссертационного совета.
            </v-card-text>
            <v-card-text class="text-xs-justify ">3. Согласия кандидатов в члены диссертационного совета на вхождение
              в состав диссертационного совета по соответствующей специальности и на обработку персональных данных.
            </v-card-text>
          </v-flex>

        </v-layout>


        <v-text-field
          class="mx-3 mt-5 mb-1"
          label="Должность рук,наименование структурного подразделения, ученое звание,степень,ФИО"
          outline
          v-model="user"
          readonly
        ></v-text-field>

        <template v-for="(error, index) in errors">
          <v-alert color="error" :value="hasError('non_field_errors')">
            {{getErrorArray('non_field_errors')}}
          </v-alert>
        </template>

        <v-alert
          :value="alert"
          color="green"
          dark

          dismissible
        >
          {{alertText}}
        </v-alert>
        <v-layout>
          <v-flex>
            <v-btn class="primary" @click="apply"
                   :disabled="answer > 0 ? true : false"
            >Сохранить заявку
            </v-btn>
            <v-btn class="primary" @click="dialog = true"
                   :disabled="answer > 0 ? false : true">Подать пакет документов
            </v-btn>
            <v-btn class="primary" @click="printPDF" :disabled=generatePdf>
            <span v-if="!show_loadind">
              Сформировать PDF
            </span>
              <span v-else style="padding-left: 65px; width: 149px; align-content: center; text-align: center;">
              <semipolar-spinner
                :animation-duration="2000"
                :size="20"
                color="#1935ff"
              />
            </span>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex>
            <v-btn class="primary" @click="recall"
                   :disabled="answer > 0 ? false : true"
            >Отозвать текущую заявку
            </v-btn>
            <v-btn class="primary" @click="copyFrom"
                   :disabled="answer > 0 ? false : true"
            >Скопировать прошлую заявку
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card>

    </v-layout>
    <v-dialog max-width="400" persistent v-model="dialog">
      <v-card>
        <v-card-title class="headline">Сохранить пакет документов?</v-card-title>
        <v-card-text>После отправки данных, редактирование трех форм будет не возможно. Заявке будет присвоен статус
          подано. Вы, действительно хотите отправить данные?
        </v-card-text>
        <v-card-actions>

          <v-btn @click="dialog = false" color="red darken-1" flat>Отменить</v-btn>

          <v-spacer></v-spacer>
          <v-btn @click="send" color="green darken-1" flat>Отправить</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-flex>
</template>

<script>
    import urlsW from "../../urlsW.js"
    import urlsU from "../../urlsU.js"
    import UserDataFormMixin from '../../../../mixins/UserDataFormMixin'
    import urls from "../../urls.js"
    import {makeGetRequest, makeManagerUrl, makePostRequest} from "../../../../helper";
    import selectors from "../../selectors";
    import {SemipolarSpinner} from 'epic-spinners'

    export default {
        name: "CouncilCreation",
        components: {SemipolarSpinner},
        mixins: [UserDataFormMixin],
        props: {
            id: Number,
            departments: String,
            responsible: String,
        },
        data() {
            return {
                URL_CREATE: makeManagerUrl(urls.getUrl('admin|petition|petition|petition_create_permanent_council-list', 'create')),
                URL_UPDATE: makeManagerUrl(urls.getUrl('admin|petition|petition|petition_create_permanent_council-detail', 'retrieve')),
                user: "Должность,наимен струк подр, уч зв, степень,ФИО",
                answer: 0,
                dialog: false,
                loaders: {
                    responsible: {
                        status: true,
                        handler: () => this.load(this, urlsW.getUrl('selectors|employee|worker', 'get'))
                    },
                    departments: {
                        status: true,
                        handler: () => {
                            this.getChoices(
                                // educational-
                                urlsW.getUrl('selectors|department-educational-uid', 'get').replace('<organization_id>', '1'),
                            ).then(choices => {
                                this.selectors.department.items = choices;
                                // this.getChoices(
                                //     urlsW.getUrl('department|self-pps-position-department', 'get')
                                // ).then(json => {
                                //     this.value.departments.push(json.uid);
                                //     this.selectors.department.self = json.uid;
                                //     // this.selectors.department.items.find((item) => json.uid === item.value).disabled = true
                                this.loaders.departments.status = false;
                                // });
                            });
                        }
                    },
                    user: {
                        status: true,
                        handler: () => {
                            makeGetRequest(
                                urlsW.getUrl('self_worker-title', 'title')
                            ).then(resp => resp.json())
                                .then(json => {
                                    this.user = json.title
                                });
                        }
                    }
                },
                selectors: {
                    department: {
                        items: [],
                        max: 3,
                        self: null,
                        disabled: (item) => {
                            if (this.selectors.department.self === item.value)
                                return true;
                            else if (this.value.departments.indexOf(item.value) !== -1)
                                return false;
                            else if (this.value.departments.length >= this.selectors.department.max)
                                return true;
                            else
                                return false;
                        }
                    },
                    responsible: [],
                    speciality: selectors.speciality,
                    branch: selectors.branch,
                },
                alert: false,
                alertText: "",
                disabled: false,

                value: {
                    specialities: [
                        {
                            speciality: null,
                            branch: null
                        },
                    ],
                    vice_chairmans: [
                        {
                            fio: "",
                            worker: "",
                            organization: "",
                            type: false,
                        }
                    ],
                    count_council_members: 0,
                    count_doctors: 0,
                    count_staff: 0,
                    rationale: "",
                    departments: [],
                    scientific_secretary: "",
                    chairman: "",
                },
                generatePdf: true,
                show_loadind: false,
            }
        },

        methods: {
            allowed(urlname, action) {
                return urls.getUrlAllowed(urlname, action)
            },
            download(content, fileName, contentType) {
                var a = document.createElement("a");
                a.href = URL.createObjectURL(content);
                a.download = fileName;
                a.click();
            },
            addDataChairman() {

                this.value.vice_chairmans.push(
                    {
                        fio: "",
                        worker: "",
                        organization: "",
                        type: false,
                    })
            },
            addData() {
                if (this.value.specialities.length < 3)
                    this.value.specialities.push(
                        {
                            speciality: null, branch: null
                        })
            },
            copyFrom() {
                let url = urls.getUrl('admin|petition|petition|petition_create_permanent_council-copy-from', "copy_from").replace('<id>', this.answer)
                let status = false;
                let data = {}
                // console.log(data);
                makePostRequest(url, data, "PATCH")
                    .then(resp => {
                        if (resp.ok) {
                            status = false;
                        }
                        return resp.json();
                    })
                    .then(json => {
                        if (json['changed']) {
                            this.getUserData();
                            this.alert = true;
                            this.alertText = "Заявка успешно скопирована"
                            // this.$emit('setPetition', undefined)
                        }
                    });
            },
            recall() {
                let url = urls.getUrl('admin|petition|petition|petition_create_permanent_council-recall', "recall").replace('<id>', this.answer)
                let status = false;
                let data = {}
                // console.log(data);
                makePostRequest(url, data, "PATCH")
                    .then(resp => {
                        if (resp.ok) {
                            status = false;
                        }
                        return resp.json();
                    })
                    .then(json => {
                        if (json['changed']) {
                            this.disabled = false;
                            this.generatePdf = true;
                            this.answer = 0;
                            this.alert = true;
                            this.alertText = "Заявка успешно отозвана"
                            this.$emit('setPetition', undefined)
                        }
                    });
            },
            send() {
                let url = urls.getUrl('admin|petition|petition|petition_create_permanent_council-send', "send").replace('<id>', this.answer)
                let status = false;
                let data = {}
                // console.log(data);
                makePostRequest(url, data, "PATCH")
                    .then(resp => {
                        if (resp.ok) {
                            status = false;
                        }
                        return resp.json();
                    })
                    .then(json => {
                        if (json['changed']) {
                            this.disabled = false;
                            this.generatePdf = false;
                            this.dialog = false
                            this.alert = true;
                            this.alertText = "Пакет успешно сформирован"
                        } else {
                            this.dialog = false
                            this.alert = true;
                            this.alertText = "Пакет не сформирован"
                        }
                    });
            },
            getUserData() {

                makeGetRequest(
                    urls.getUrl('admin|petition|petition|petition_create_permanent_council-actual-previous', 'actual_previous'),
                ).then(resp => resp.json())
                    .then(json => {
                        if (json.existed) {
                            let RealData = json.object

                            let users = [];
                            users.push(RealData.creator)
                            makePostRequest(
                                urlsU.getUrl('users|user|fio', 'post'),
                                {'uids': users}
                            )
                                .then(resp => resp.json())
                                .then(json => {
                                    this.user = json[0].text
                                })
                            this.value.specialities = RealData.specialities;
                            for (var key in RealData.departments) {
                                // var dep = this.value.departments.find(departments => departments.value === RealData.departments[key].uid);
                                // if (dep !== undefined)
                                this.value.departments.push({"value": RealData.departments[key].uid});
                            }
                        }


                        makeGetRequest(
                            urls.getUrl('admin|petition|petition|petition_create_permanent_council-actual', 'actual'),
                        ).then(resp => resp.json())
                            .then(json => {
                                if (json.existed) {
                                    let RealData = json.object

                                    // for (var key in  RealData.departments) {
                                    //     var dep = this.value.departments.find(departments => departments.value === RealData.departments[key].uid);
                                    //     if(dep !== undefined)
                                    //         this.value.departments.push({"value":RealData.departments[key].uid});
                                    // }
                                    this.value.vice_chairmans = []
                                    for (var key in RealData.vice_chairmans) {
                                        if (RealData.vice_chairmans[key].worker !== null) {
                                            this.value.vice_chairmans.push({
                                                fio: "",
                                                worker: RealData.vice_chairmans[key].worker,
                                                organization: "",
                                                type: false,
                                            })
                                        } else {
                                            this.value.vice_chairmans.push({
                                                fio: RealData.vice_chairmans[key].fio,
                                                worker: "",
                                                organization: RealData.vice_chairmans[key].organization,
                                                type: true,
                                            })
                                        }
                                    }


                                    if (this.value.specialities.length > 0) {
                                        this.value.specialities = RealData.specialities;
                                    }

                                    this.value.count_council_members = RealData.count_council_members,
                                        this.value.count_doctors = RealData.count_doctors,
                                        this.value.count_staff = RealData.count_staff,
                                        this.value.rationale = RealData.rationale,

                                        this.value.scientific_secretary = RealData.scientific_secretary,
                                        this.value.chairman = RealData.chairman,
                                        this.disabled = false;
                                    this.generatePdf = false;
                                    this.answer = RealData.id
                                    this.$emit('setPetition', this.answer)
                                }
                            })

                    })
            },
            printPDF() {
                this.generatePdf = true;
                this.show_loadind = true;
                let status = true;
                const type = "application/pdf";
                const name = 'file.pdf';
                makeGetRequest(
                    urls.getUrl('admin|petition|petition|petition_create_permanent_council-make-file', 'make_file').replace('<id>', this.answer),
                ).then(resp => {
                    if (!resp.ok) {
                        status = false;
                    }
                    return resp.blob();
                }).then(blob => {
                    this.download(blob, name, type);
                    this.generatePdf = false;
                    this.show_loadind = false;
                })

            },
            deleteData(idx, key) {
                if (this.value[key].length > 1)
                    this.value[key].splice(idx, 1);
            },
            text: item => item.code + ' - ' + item.name,
            apply() {
                let url = this.getCreateUrl();

                let sendData = Object.assign({}, this.value);
                let chairmans = Object.assign({}, sendData.vice_chairmans);
                delete sendData.vice_chairmans
                let data = sendData;
                data.count_council_members = Number(data.count_council_members)
                data.count_doctors = Number(data.count_doctors)
                data.count_staff = Number(data.count_staff)
                data.vice_chairmans = []
                for (var key in chairmans) {
                    if (chairmans[key].type) {
                        data.vice_chairmans.push(
                            {
                                fio: chairmans[key].fio,
                                organization: chairmans[key].organization
                            }
                        )
                    } else {
                        {
                            data.vice_chairmans.push(
                                {
                                    worker: chairmans[key].worker
                                }
                            )

                        }
                    }
                }

                delete data.responsible
                delete data.departments
                // delete data.specialities

                let status = true;

                makePostRequest(url, data)
                    .then(resp => {
                        if (!resp.ok) {
                            status = false;
                        }
                        return resp.json();
                    })
                    .then(json => {
                        if (status) {
                            this.alert = true;
                            this.alertText = "Заявка успешно создана"
                            this.generatePdf = false;
                            this.disabled = true;
                            this.answer = json.id
                            this.$emit('setPetition', this.answer)
                        } else {
                            this.receiveErrors(json);
                        }
                    })
            },
            load: function (app, url) {
                if (url === null) {
                    app.loaders.responsible.status = false;
                    return;
                }
                makeGetRequest(url)
                    .then(resp => resp.json())
                    .then(json => {
                        let users = [];
                        let results = [];
                        let next_url = null;
                        if (json['next'] !== null)
                            next_url = url.split('?')[0] + '?' + json['next'].split('?')[1];
                        for (let i in json['results']) {
                            users.push(json['results'][i].value);
                            results.push(Object.assign({}, json['results'][i]));
                        }
                        makePostRequest(
                            urlsU.getUrl('users|user|fio', 'post'),
                            {'uids': users}
                        )
                            .then(resp => resp.json())
                            .then(json => {
                                for (let i in json) {
                                    let replaced = results.find((item) => item.value === json[i].value);
                                    replaced.text = json[i].text + ' (' + replaced.text + ')';
                                    app.selectors.responsible.push(replaced)
                                }
                                results = null;
                                app.load(app, next_url);
                            });
                    });
            },
        },
        created() {

            this.loaders.responsible.handler();
            this.loaders.departments.handler();
            // this.loaders.user.handler();
            this.getUserData();
            this.$store.commit('mainpage/changeTitle', 'Ходатайство о подачи заявки на создание диссертационного совета');
        },
        // beforeRouteEnter(to, from, next){
        //     makeGetRequest(urls.getUrl('admin|petition|checker|petition|self-local-admin', 'get'))
        //         .then((resp) => {
        //             return resp.json();
        //         }).then((json) => {
        //         let local_admin = json['allowed'];
        //         if(local_admin) {
        //           next({name: 'ListDiss', query: {local_admin: local_admin}});
        //         }else{
        //           next()
        //         }
        //     });
        //
        // },
    }

</script>

<style scoped>

</style>
